import moment from 'moment-timezone';
import { Prescription } from 'src/interfaces';

export const VALID_PRESCRIPTION_THRESHOLD = moment.duration(1, 'year');

export const isPrescriptionValid = (p: Prescription) =>
  moment.utc(p.prescribedAt).isSameOrAfter(moment().subtract(VALID_PRESCRIPTION_THRESHOLD), 'day');
